module.exports = __webpack_public_path__ + "img/14.b189e649.jpg";